const refs = {
    brands: { ref: "brands", value: "$.policy.properties[?(@.type=='VEHICLE')].brand", type: 'case' },
    vehicle_models: { ref: "vehicle_models", value: "$.policy.properties[?(@.type=='VEHICLE')].model", type: 'case' },
    vehicle_energies: { ref: "vehicle_energies", value: "$.policy.properties[?(@.type=='VEHICLE')].energy", type: 'case' },
    vehicle_types: { ref: "vehicle_types", value: "$.policy.properties[?(@.type=='VEHICLE')].type", type: 'case' },
    history: { ref: "history", value: "$.services[*]..history" },
    history_types: { ref: "history_types", value: "$.services[*]..history.type", type: 'case' },
    history_subtypes: { ref: "history_subtypes", value: "$.services[*]..history.subtype", type: 'case' },
    customer_codes: { ref: "customer_codes", value: "$.customer_code", type: 'case' },
    countries: { ref: "iso2Countries", value: "$.event.country_code", type: 'case' },
    code_regions: {ref: "code_regions",  value: "$.event.region_code", type: 'case' },
    vehicule_countries: { ref: "iso2Countries", value: "$.policy.properties[?(@.type=='VEHICLE')].localization.country_code", type: 'case' },
    originInformationsMCS: { ref: "originInformationsMCS", value: "$.event.origin.informations", type: 'case' },
    originTypes: { ref: "diagnostics", value: "$.event.origin.type", type: 'case' },
    formules: { ref: "formules", value: "$.policy.id", type: 'case' },
    demandes: { ref: "demandes", value: "$.person_assisted.informations.request", type: 'case' },
    status: { ref: "$.change_history.status", value: "$.change_history.status", type: 'case' },
    employee_id: { ref: "$.change_history.employee_id", value: "$.change_history.employee_id", type: 'case' },
    external_id: { ref: "external_id", value: "external_id", type: 'case' },
    //SDR
    modele_vehicule: { ref: "vehicle_models", value: "$.code_modele" },
    code_client: {ref: "code_client", value: "$.customer_code"},
    marque: { ref: "brands", value: "$.code_marque" },
    energie_vehicule: { ref: "vehicle_energies", value: "$.code_energie" },
    caupancli: {ref: "caupancli", value: "$.caupancli"},
    etat_sdr: {ref: "etat_sdr", value: "$.etat_avancement"},
    statut_mobilite: {ref: "statut_mob", value: "$.statut"},
    mode_depot: {ref: "mode_depot", value: "$.mode_arrivee"},
    type_sdr: {ref: "type_sdr", value: "$.type_sdr"},
    motif_repa: {ref: "motif_repa", value: "$.motif_repa"},
    type_mobil: {ref: "type_mobil", value: "$.type_mobilite"},
    sdr_motclo: {ref: "sdr_motclo", value: "$.sdr_motclo"},
    sdr_tyveco: {ref: "sdr_tyveco", value: "$.sdr_tyveco"},
    sdr_mobref: {ref: "sdr_mobref", value: "$.sdr_mobref"},
    garage_pays: { ref: "countries", value: "$.adresse_garage.pays"},
    garage_departement: { ref: "code_regions", value: "$.adresse_garage.region"}
};
export const REF_ENUM = refs;

const localRefs = {
    roles: { value: "roles" },
    activities: { value: "activities" },
    customers_types: { value: "customers_types" },
    status: { value: "$.change_history.status" },
    etat_avancement: { value: "$.etat_avancement" },
    statut: { value: "$.statut" }
};
export const REF_LOCAL_ENUM = localRefs;

// TODO trouver un référentiel
const sites = [
    { code: 'F', value: "Niort" },
    { code: 'E', value: "Madrid" },
    { code: 'I', value: "Milan" },
    { code: 'D', value: "Munich" },
    { code: 'B', value: "Liège" },
    { code: 'M', value: "Casablanca" },
    { code: 'P', value: "Lisbonne" }
]
export const SITES = sites;

const TranscoUtils = {

    getLabel(key, ref) {
        return TranscoUtils.getLabelByName(key, ref.value);
    },

    getLabelByName(key, refValue) {
        key = key ? key.toString().toUpperCase() : key;
        let label = key;
        try {
            const map = localStorage.getItem(refValue);
            if (map) {
                if (refValue === REF_ENUM.customer_codes.value) {
                    // Suppression du code site devant le code client
                    const key2 = key.substring(1, key.length);
                    label = JSON.parse(map)[key2] ? JSON.parse(map)[key2] : key;
                } else {
                    label = JSON.parse(map)[key] ? JSON.parse(map)[key] : key;
                }
                if (label === key && key.includes('_')) {
                    const key2 = key.split('_')[1];
                    label = JSON.parse(map)[key2] ? JSON.parse(map)[key2] : key;
                }
            }
        } catch (error) { }
        label = label && typeof label === 'string' ? label.replace('{', 'é') : label; // FIXME Corriger les référentiels ?
        return label;
    }
}

export default TranscoUtils;